import Header from "./components/Header";
import Banner from "./components/Banner";
import TitleIntroduce from "./components/TitleIntroduce";
import Video from "./components/Video";
import BriefDescription from "./components/BriefDescription";
import ApplicationQualification from "./components/ApplicationQualification";
import ApplicationProcedures from "./components/ApplicationProcedures";
import CommonQuestion from "./components/CommonQuestion";
import JoinUs from "./components/JoinUs";
import ToTopButton from "./components/ToTopButton";
import Footer from "./components/Footer";

function App() {
  return (
    <>
      <Header />
      <div className="bg-main bg-repeat">
        <main className="pt-46px sm:pt-50px relative">
          <Banner />
          <TitleIntroduce />
          <Video />
          <BriefDescription />
          <ApplicationQualification />
          <ApplicationProcedures />
          <CommonQuestion />
          <JoinUs />
          <ToTopButton />
        </main>
      </div>
      <Footer />
    </>
  );
}

export default App;
